import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity, closeDrawer, getURLSegment } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import Textarea from 'react-textarea-autosize';
import platform from 'platform';
import LogRocket from 'logrocket';
// import Dropzone from 'react-dropzone';

// Components
// import * as icons from '../Icons/Icons';

const TicketForm = observer(class TicketForm extends React.Component {
  constructor() {
    super();
    // this.handleDrop = this.handleDrop.bind(this);
    // this.handleDragEnter = this.handleDragEnter.bind(this);
    // this.handleDragLeave = this.handleDragLeave.bind(this);
    // this.removeFile = this.removeFile.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.complete = this.complete.bind(this);
    this.resolve = this.resolve.bind(this);
  }

  componentWillMount() {
    this.state = {
      attachment: [],
      dropClass: '',
      status: 'open',
      body: '',
      formClass: '',
      logRocketUrl: null
    }

    if(this.props.newTicket) {
      if(this.props.store.SessionStore.userData.role.toLowerCase() !== 'administrator') {
        this.props.store.CourseStore.getExams(null, true);
      }
    }
  }

  componentDidMount() {
    const { SessionStore } = this.props.store;

    if(SessionStore.logRocketInit) {
      LogRocket.getSessionURL(sessionUrl => {
        this.setState({
          logRocketUrl: sessionUrl
        });
      });
    }
  }

  // handleDrop(file) {
  //   let attachment = [...this.state.attachment.concat(file)];
  //
  //   console.log(file);
  //
  //   this.setState({
  //     attachment,
  //     dropClass: ''
  //   });
  // }
  //
  // handleDragEnter() {
  //   this.setState({
  //     dropClass: 'file-drop--drag-enter'
  //   });
  // }
  //
  // handleDragLeave() {
  //   this.setState({
  //     dropClass: ''
  //   });
  // }
  //
  // removeFile(i) {
  //   let attachment = [...this.state.attachment];
  //   attachment.splice(i, 1);
  //
  //   this.setState({
  //     attachment
  //   })
  // }

  handleSubmit(e) {
    e.preventDefault();

    const { SessionStore, TicketStore } = this.props.store;
    const { activeTicket } = TicketStore;

    let data = null;

    if(this.props.newTicket) {
      data = {
        subject: this.subject.value,
        details: this.comment.value,
        enrollmentSid: SessionStore.userData.enrollmentSid,
        browserInformation: platform.toString(),
        domain: window.location.host
      }

      if(this.examSid) {
        data.examSid = this.examSid.value;
      }

      if(this.state.logRocketUrl && this.state.logRocketUrl.indexOf('http') > -1) {
        data.clientSessionUrl = this.state.logRocketUrl;
      }

      TicketStore.postTicket(data, this.complete);
    } else {
      data = {
        body: this.comment.value,
        userSid: SessionStore.userData.userSid
      }

      this.comment.value = '';

      this.setState({
        formClass: 'form-sending'
      });

      TicketStore.postReply(activeTicket.sid, data, this.complete);
    }
  }

  complete() {
    if(this.props.newTicket) {
      const segment1 = getURLSegment(this, 1);

      closeDrawer(null, this.props.parent, segment1);

      this.props.store.SessionStore.showToaster(this.props.translation.ticket_submitted, 'success');
    } else {
      this.setState({
        formClass: ''
      });

      // Remove any errors
      const form = document.querySelector('.reply__form');
      const fieldset = form.querySelector('fieldset');
      const error = form.querySelector('.note--error');
      form.classList.remove('submitted');
      if(error) {
        fieldset.removeChild(error);
      }
    }
  }

  resolve(e) {
    e.preventDefault();

    const { TicketStore } = this.props.store;
    const { activeTicket } = TicketStore;

    TicketStore.updateTicket(activeTicket.sid, 'Resolved');

    if(typeof this.comment !== 'undefined' && this.comment.value) {
      this.handleSubmit(e);
    }
  }

  reopen(e) {
    e.preventDefault();

    const { TicketStore } = this.props.store;
    const { activeTicket } = TicketStore;

    TicketStore.updateTicket(activeTicket.sid, 'Open');
  }

  render() {
    const { activeTicket, newTicket, store, translation } = this.props;
    const { exams } = store.CourseStore;

    return(
      <form className={`reply__form ${this.state.formClass}`} onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
        {(
          newTicket ||
          (
            typeof activeTicket !== 'undefined' &&
            activeTicket.status.toLowerCase() !== 'closed' &&
            activeTicket.status.toLowerCase() !== 'resolved'
          )
        ) &&
          <div className="panel--medium">
            <fieldset>
              <ul className="fields">
                {newTicket &&
                  <li>
                    <label className="lbl-required" htmlFor="ticket-subject">{translation.subject.label}</label>
                    <input
                      type="text"
                      id="ticket-subject"
                      placeholder={translation.subject.helper}
                      ref={(input) => {this.subject = input}}
                      required
                      aria-required="true"
                    />
                  </li>
                }
                {newTicket && exams.length > 0 &&
                  <li className="field--auto">
                    <label className="lbl-optional" htmlFor="ticket-exam">
                      {translation.exam.label}
                    </label>

                    <label className="select" htmlFor="ticket-exam">
                      <select
                        ref={(input) => {this.examSid = input}}
                      >
                        <option value="">{translation.exam.helper}</option>
                        {exams.map(
                          (key, i) =>
                          <option key={i} value={key.sid}>{key.title}</option>
                        )}
                      </select>
                    </label>
                  </li>
                }
                <li>
                  <label className="lbl-required" htmlFor="ticket-comment">{translation.comments.label}</label>
                  <Textarea
                    id="ticket-comment"
                    className="textarea-grow"
                    placeholder={translation.comments.helper}
                    ref={(input) => {this.comment = input}}
                    onChange={this.handleInput}
                    required
                    aria-required="true"
                  ></Textarea>
                </li>
                {/* <li>
                  <Dropzone
                    className={`file-drop file-drop--small ${this.state.dropClass}`}
                    onDrop={this.handleDrop}
                    onDragEnter={this.handleDragEnter}
                    onDragLeave={this.handleDragLeave}
                    multiple={true}
                  >
                    <label className="file-drop__label">{translation.attachment.label}</label>
                  </Dropzone>

                  {this.state.attachment.map(
                    (file, i) =>
                    <div key={i} className="file-drop__files">
                      <span>{file.name}</span>
                      <button className="btn--remove" type="button" onClick={() => {this.removeFile(i)}}><icons.iconMinus /><span className="meta">{translation.attachment.remove} {file.name}</span></button>
                    </div>
                  )}
                </li> */}
              </ul>
            </fieldset>

            <em className="form-note">{translation.note}</em>

            <button className="btn" type="submit">{translation.submit}</button>

            {
              typeof activeTicket !== 'undefined' &&
              activeTicket.status.toLowerCase() !== 'closed' &&
              activeTicket.status.toLowerCase() !== 'resolved' &&
              <button
                className="btn btn--outline"
                type="submit"
                onClick={(e) => {this.resolve(e)}}
              >
                {translation.resolve}
              </button>
            }
          </div>
        }

        {
          typeof activeTicket !== 'undefined' &&
          (
            activeTicket.status.toLowerCase() === 'resolved' ||
            activeTicket.status.toLowerCase() === 'closed'
          ) &&
          <div className="panel--medium">
            <p>{translation.resolved_note}</p>

            <button
              className="btn btn--outline"
              onClick={(e) => {this.reopen(e)}}
            >
              {translation.reopen}
            </button>
          </div>
        }
      </form>
    )
  }
})

export default translate('TicketForm')(TicketForm);



// WEBPACK FOOTER //
// ./src/app/components/SupportTickets/TicketForm.js